// src/components/customers/CustomersTable.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const fmtDate = (s)=> s ? new Date(s).toLocaleDateString() : "";

export default function CustomersTable({ rows, sort, order, onSort }) {
    const navigate = useNavigate();

    const renderHeader = (label, field, style = {}) => {
      const isSorted = sort === field;
      const direction = isSorted ? (order === "ASC" ? "▲" : "▼") : "";
      return (
        <th 
          style={{ cursor: "pointer", userSelect: "none", ...style }} 
          onClick={() => onSort && field ? onSort(field) : null}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>{label}</span>
            {field && (
              <span style={{ fontSize: "10px", opacity: isSorted ? 1 : 0.3, marginLeft: 4 }}>
                {isSorted ? direction : "↕"}
              </span>
            )}
          </div>
        </th>
      );
    };

  return (
    <div className="oc-table-wrap">
      <table className="oc-table">
        <thead>
      <tr>
      <th colSpan="11">

        <button type="button" className="btn btn-primary" onClick={() => navigate("/customers/new")} >
            <i className="fa fa-plus" /> <span style={{ marginLeft: 6 }}>Create Customer</span>
          </button>
      </th>

      </tr>
          <tr>
            <th style={{width:36}}><input type="checkbox" /></th>
            {renderHeader("ID", "c.customer_id", { width: 80 })}
            {renderHeader("Customer Name", "name")}
            {renderHeader("E-Mail", "c.email")}
            {renderHeader("Telephone", "c.telephone")}
            {renderHeader("Status", "c.status")}
            {renderHeader("IP", "c.ip")}
            {renderHeader("Customer Group", "customer_group")}
            {renderHeader("Platform", "c.platform")}
            {renderHeader("Date Added", "c.date_added", { width: 140 })}
            <th style={{width:120}}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c)=>(
            <tr key={c.customer_id || c.id}>
              <td><input type="checkbox" /></td>
              <td className="oc-mono">{c.customer_id ?? c.id}</td>
              <td>{c.name}</td>
              <td className="oc-mono">{c.email}</td>
              <td className="oc-mono">{c.telephone}</td>
              <td>
                {String(c.status)==="1" || c.status===true
                  ? <span className="oc-badge green">Enabled</span>
                  : <span className="oc-badge gray">Disabled</span>}
              </td>
              <td className="oc-mono">{c.ip || ""}</td>
              <td>{c.customer_group || c.customer_group_name || "Default"}</td>
              <td>{c.platform || ""}</td>
              <td className="oc-mono">{fmtDate(c.date_added)}</td>
              <td>
                <div className="oc-row-actions">
                  <Link to={`/customers/${c.customer_id ?? c.id}`}>
                    <button className="oc-ico-btn" title="Edit">✏️ </button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
          {rows.length===0 && (
            <tr><td colSpan={11} style={{textAlign:"center",padding:24}}>No customers found</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

